import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-35c7a524"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
const _hoisted_2 = ["src"];
const _hoisted_3 = ["id"];
const _hoisted_4 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mappopup = _resolveComponent("mappopup");
  const _component_maptype = _resolveComponent("maptype");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mapcontainer", [`width${$data.bodywidth}`, {
      'ipad': $data.isIpad
    }]])
  }, [_createElementVNode("img", {
    class: "mapbg",
    src: $options.handleHttp($data.mapconfigData.mapbg),
    alt: ""
  }, null, 8, _hoisted_1), _createElementVNode("div", {
    class: _normalizeClass(["logo", [{
      'mobile': $data.isApp
    }, `model${$data.modeltype}`, `fid${$data.fid}`, `id${$data.formUserId}`]]),
    style: _normalizeStyle($data.jsonOption.logo)
  }, [_createElementVNode("img", {
    class: "logoimg",
    src: $options.handleHttp($props.mapconfigdatas.logo),
    alt: ""
  }, null, 8, _hoisted_2)], 6), _createElementVNode("div", {
    id: `map${$props.id}`,
    class: "map_content",
    ref: `map${$props.id}`
  }, null, 8, _hoisted_3), _withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["pickey", [{
      'mobile': $data.isApp
    }, `fid${$data.fid}`]]),
    style: _normalizeStyle($data.jsonOption.pickey)
  }, [_createElementVNode("img", {
    src: $options.handleHttp($props.mapconfigdatas.pickey),
    alt: ""
  }, null, 8, _hoisted_4)], 6), [[_vShow, $props.mapconfigdatas.pickey]]), _createVNode(_component_mappopup, {
    detail: $data.detail,
    popshowflag: $data.popshowflag,
    modeltype: $data.modeltype,
    bodywidth: $data.bodywidth,
    onCloseHandle: $options.closeHandle
  }, null, 8, ["detail", "popshowflag", "modeltype", "bodywidth", "onCloseHandle"]), $data.typeshow ? (_openBlock(), _createBlock(_component_maptype, {
    key: 0,
    typedata: $data.typeList,
    jsonOption: $data.jsonOption,
    currentType: $data.currentType,
    typemodel: $data.typemodel,
    ispc: $data.isApp,
    onTypeclick: $options.typeselect
  }, null, 8, ["typedata", "jsonOption", "currentType", "typemodel", "ispc", "onTypeclick"])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["goback", `fid${$data.fid}`]),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.gobackright && $options.gobackright(...args))
  }, null, 2), [[_vShow, $data.fid === '16664']])], 2);
}